var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.932,
    height: 26.932,
    viewBox: "0 0 26.932 26.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(-23.263 2.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "transition",
    d: "M17.411,0A9.511,9.511,0,0,0,8.056,8.055,9.493,9.493,0,1,0,18.877,18.876,9.493,9.493,0,0,0,17.411,0ZM9.521,25.354a7.917,7.917,0,1,1,0-15.833A7.853,7.853,0,0,1,14.512,11.3L8.174,17.642,9.29,18.758l6.338-6.338A7.925,7.925,0,0,1,9.521,25.354Zm9.466-8.1a9.425,9.425,0,0,0-2.24-5.953L19.778,8.27v3.618h1.578V5.576H15.044V7.154h3.618l-3.031,3.031a9.425,9.425,0,0,0-5.953-2.24,7.914,7.914,0,1,1,9.308,9.308Z",
    transform: "translate(23.263 -2.437)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransition);
export default __webpack_public_path__ + "static/media/icon-transition.88e71294da1e08d6b8aba06a323ff97d.svg";
export { ForwardRef as ReactComponent };